// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 676 ? "9932c28f" : chunkId) + "." + {"249":"8b65c43ffacfd4b0","676":"02da64c387e40518","698":"ac0a4adbb8ec3e60"}[chunkId] + ".js";
};